import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { GlobalModule } from '@techmore/global';
import { UPLOAD_ASSETS, UploadModule } from '@techmore/upload';
import { NgxLoadingModule } from '@techmore/loading';
import { NgxPageScrollModule } from 'ngx-page-scroll';
import { NgxPageScrollCoreModule } from 'ngx-page-scroll-core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthorizationTokenService } from './shared/interceptor/authorization-token.service';
import { GlobalErrorHandlerService } from './shared/interceptor/global-error-handler.service';
import { HttpErrorInterceptorService } from './shared/interceptor/http-error-interceptor.service';

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    NgxPageScrollCoreModule,
    NgxPageScrollModule,
    GlobalModule.forRoot(),
    UploadModule.forRoot(),
    NgxLoadingModule.forRoot({
      fullScreenBackdrop: true,
    })
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthorizationTokenService, multi: true },
    { provide: ErrorHandler, useClass: GlobalErrorHandlerService },
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptorService, multi: true },
    {
      provide: UPLOAD_ASSETS, useValue: {
        styles: ['uploader.bundle.css']
      }
    },
    provideHttpClient(withInterceptorsFromDi()),
  ]
})
export class AppModule { }
